import publications from "../../data/Publications.json";
import React from "react";
import "../../styles/Articles.css";
import { useState, useEffect } from "react";

const Publications = () => {
  const [publicationsData, setPublications] = useState({ publications: [] });
  const [error, setError] = useState(null);
  useEffect(() => {
    try {
      setPublications(publications);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!publicationsData) return <p>Loading...</p>;

  return (
    <div className="articles-list">
      <h2>Publications</h2>
      <div className="articles">
        <ol>
          {publicationsData.publications.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default Publications;
